import { Link } from '@mui/material'
import { COLORS } from 'styles/colors'

export const questionsData = [
	{
		question: 'Что входит в стоимость лицензии?',
		answer: (
			<>
				Первый год лицензионного соглашения стоит 0 рублей. Последующая
				стоимость лицензии оговаривается индивидуально по запросу. В стоимость
				лицензионного соглашения, независимо от срока использования, входит:
				представленный функционал, автоматические обновления системы и
				техническая поддержка пользователей.
			</>
		),
	},
	{
		question:
			'Что произойдет с системой, если срок действия некоторых лицензий истечет, а другие останутся активными?',
		answer: (
			<>
				В этом случае доступ к актуальной информации будет предоставляться
				только по активным лицензиям, а данные по неактивным перейдут в режим
				просмотра архивных данных.
			</>
		),
	},
	{
		question: 'Как продлить лицензионное соглашение? ',
		answer: (
			<>
				За 14 дней до истечения срока действия лицензионного соглашения на почту
				и телефон контактного лица будут отправлены уведомления о необходимости
				продлить действие договора. Для обсуждения условий продления
				лицензионного соглашения вам необходимо связаться с менеджером в
				<Link
					style={{
						color: COLORS.main,
						textUnderlineOffset: 4,
						textDecorationColor: COLORS.main,
					}}
					href='https://smartfarm.vision/help'
					target='_blank'
				>
					форме обратной связи
				</Link>
				. 
			</>
		),
	},
	{
		question:
			'Можно ли расширить лицензионное соглашение на количество голов? ',
		answer: (
			<>
				Да, увеличить количество голов или приобрести лицензионное соглашение
				для другого места внедрения на ферме возможно. Для обсуждения условий
				изменения содержания лицензионного соглашения вам необходимо связаться с
				менеджером в
				<Link
					style={{
						color: COLORS.main,
						textUnderlineOffset: 4,
						textDecorationColor: COLORS.main,
					}}
					href='https://smartfarm.vision/help'
					target='_blank'
				>
					форме обратной связи
				</Link>
				. 
			</>
		),
	},
	{
		question:
			'Зависит ли стоимость лицензии от количества мест идентификации? ',
		answer: (
			<>
				Нет, лицензия приобретается на голову и не зависит от количества мест
				идентификации. 
			</>
		),
	},
]
